// 生产环境用
const GlacierTimeLineProd: any = {
    us: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/04/26 15:00:00 GMT+8',
        detail: '2023/05/15 15:00:00 GMT+8',
    },
    ca: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/04/26 15:00:00 GMT+8',
        detail: '2023/05/15 15:00:00 GMT+8',
    },
    // 0616 欧洲六站添加两个早鸟阶段 @陈琨
    de: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00:00 GMT+8',
    },
    fr: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00:00 GMT+8',
    },
    it: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00:00 GMT+8',
    },
    es: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00:00 GMT+8',
    },
    eu: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/07/17 15:00:00 GMT+8',
    },
    uk: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/06/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/07/24 15:00:00 GMT+8',
    },
    jp: {
        crowdfunding: '2023/04/26 11:00:00 GMT+8',
        crowdfunding_stage2: '2023/05/09 23:00:00 GMT+8',
        detail: '2023/05/22 23:00:00 GMT+8', // 0515版本要求改为22号 @陈琨
    },
    cn: {
        detail: '2023/04/26 11:00:00 GMT+8',
    },
    kr: {
        detail: '2023/05/10 11:00:00 GMT+8',
    },
    // 2023/05/25上市
    sa: {
        detail: '2023/05/25 17:00:00 GMT+8',
    },
    // 2023/07/03 预热 + 详情
    au: {
        teaser: '2023/07/03 10:00:00 GMT+8',
        detail: '2023/07/18 10:00:00 GMT+8',
    },
    za: {
        teaser: '2023/09/28 10:00:00 GMT+8',
        crowdfunding: '2023/12/18 11:15:00 GMT+8',
        detail: '2024/12/18 15:00:00 GMT+8',
    },
};

const GlacierTimeLineTest: any = {
    us: {
        teaser: '2023/03/19 16:00:00 GMT+8',
        crowdfunding: '2023/04/21 17:50:00 GMT+8',
        detail: '2023/05/15 15:00:00 GMT+8',
    },
    ca: {
        teaser: '2023/03/19 16:00:00 GMT+8',
        crowdfunding: '2023/04/21 17:50:00 GMT+8',
        detail: '2023/05/15 15:00:00 GMT+8',
    },
    de: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
    },
    fr: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
    },
    it: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
    },
    es: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
    },
    eu: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/21 19:30:00 GMT+8',
        crowdfunding: '2023/05/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
    },
    uk: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 15:00:00 GMT+8',
        crowdfunding: '2023/05/16 15:00:00 GMT+8',
        crowdfunding_stage2: '2023/06/16 14:00 GMT+8',
    },
    jp: {
        crowdfunding: '2023/04/26 10:00:00 GMT+8',
        crowdfunding_stage2: '2023/05/06 23:00:00 GMT+8',
        detail: '2023/05/17 23:00:00 GMT+8',
    },
    cn: {
        detail: '2023/04/26 10:00:00 GMT+8',
    },
    kr: {
        detail: '2023/04/10 11:00:00 GMT+8',
    },
    // 2023/05/25上市
    sa: {
        detail: '2023/05/05 17:00:00 GMT+8',
    },
    // 2023/07/03 预热 + 详情
    au: {
        teaser: '2023/06/03 10:00:00 GMT+8',
        detail: '2023/06/18 10:00:00 GMT+8',
    },
    za: {
        teaser: '2023/09/28 10:00:00 GMT+8',
        crowdfunding: '2023/12/14 15:00:00 GMT+8',
        detail: '2024/12/14 15:00:00 GMT+8',
    },
};

export const getGlacierTimeline = (locale: string, flag?: boolean) => {
    return flag ? GlacierTimeLineTest[locale] || GlacierTimeLineTest.us : GlacierTimeLineProd[locale] || GlacierTimeLineProd.us;
};

export const enum STAGES {
    TEASER,
    CRODWFUNDING,
    DETAIL,
    UNKNOWN,
}

export const ACTIVITY_MAP: any = {
    us: 15,
    ca: 16,
    jp: 17,
    uk: 47,
    fr: 48,
    de: 49,
    eu: 50,
    es: 51,
    it: 52,
    za: 55,
    ph: 57,
};

export const dualTempZoneMap = {
    us: {
        singleUrl: ['fahrenheit_single_zone.webp', 'fahrenheit_single_zone.jpg'],
        dualUrl: ['fahrenheit_dual_zone.webp', 'fahrenheit_dual_zone.jpg'],
    },
    za: {
        singleUrl: ['celsius_single_zone.webp', 'celsius_single_zone.jpg'],
        dualUrl: ['celsius_dual_zone.webp', 'celsius_dual_zone.jpg'],
    },
};

export const quickFreezingVideoMap = {
    us: {
        videoUrl: ['fahrenheit_quick_freezing.webm', 'fahrenheit_quick_freezing.mp4'],
    },
    za: {
        videoUrl: ['celsius_quick_freezing.webm', 'celsius_quick_freezing.mp4'],
    },
};

export const youtubeVideoMap = {
    us: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    ca: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    eu: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    uk: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    de: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    fr: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    it: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    es: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    jp: 'https://www.youtube.com/embed/TNMVsi7NOcA',
    kr: 'https://www.youtube.com/embed/tuFVZnBliLo',
    cn: {
        SD: 'https://videos.ecoflow.com/c6a72c90e3d471edb59d7630a6ac0102/0172b3c9b97d2fa854028d4b2ff1a393-ld.mp4',
        HD: 'https://videos.ecoflow.com/c6a72c90e3d471edb59d7630a6ac0102/be544404d0d37fd3c0043bf8124cc7ee-sd.mp4',
        '2K': 'https://videos.ecoflow.com/c6a72c90e3d471edb59d7630a6ac0102/36622d0691d1296e525c7fe9f4f6730d-hd.mp4',
    },
};

export const chillinVideo = (locale: string): string => {
    const videoMap: any = {
        us: 'https://www.youtube.com/embed/p0-CB_-u_nk', // us/ca/eu/uk 20230518 @周佳伟要求换视频
        ca: 'https://www.youtube.com/embed/p0-CB_-u_nk',
        eu: 'https://www.youtube.com/embed/p0-CB_-u_nk',
        uk: 'https://www.youtube.com/embed/p0-CB_-u_nk',
        de: 'https://www.youtube.com/embed/flv-MgCv8n4',
        fr: 'https://www.youtube.com/embed/a_nVlD8EjoA',
        it: 'https://www.youtube.com/embed/CeJAwTEJc5Q',
        es: 'https://www.youtube.com/embed/jAQ6zuFjjts',
        jp: 'https://www.youtube.com/embed/GWfjw2drxqQ',
        kr: 'https://www.youtube.com/embed/QcoHfbC5yFs',
        cn: {
            SD: 'https://videos.ecoflow.com/6b5ca200e1b071ed802c4710b4ba0102/d84892ac6b6a5095dfdf2b109528993d-ld.mp4',
            HD: 'https://videos.ecoflow.com/6b5ca200e1b071ed802c4710b4ba0102/738bda75491b5c8aec2faf0614312a6d-sd.mp4',
            '2K': 'https://videos.ecoflow.com/6b5ca200e1b071ed802c4710b4ba0102/ad6d05d6b2e19922a08db2582b2bd841-hd.mp4',
        },
    };
    return videoMap[locale as keyof typeof videoMap] || videoMap.us;
};

export const remoteControlImg = (locale: string, suffix: string): Array<string> => {
    const localeArr = ['us', 'de', 'fr', 'it', 'es', 'nl', 'cn', 'jp', 'kr', 'cis', 'za'];
    const srcLocale = localeArr.includes(locale) ? locale : 'za';

    return [`app_${srcLocale}.webp`, `app_${srcLocale}.${suffix}`];
};

export const discoverARMap = (locale: string) => {
    const arMap = {
        us: ['glacier_detail_1_f.glb', 'glacier_detail_2_f.glb'],
        za: ['glacier_detail_1_c.glb', 'glacier_detail_2_c.glb'],
    };
    return arMap[locale as keyof typeof arMap] || arMap.za;
};

// 一图看懂

export const appControlImg = (locale: string): Array<string> => {
    const localeArr = ['us', 'de', 'fr', 'it', 'es', 'nl', 'cn', 'jp', 'kr', 'cis', 'za'];
    const srcLocale = localeArr.includes(locale) ? locale : 'za';
    return [`app_control_${srcLocale}.webp`, `app_control_${srcLocale}.png`];
};

export const iceMakerImg = (locale: string): Array<string> => {
    const arMap = {
        us: ['ice_maker_fahrenheit.webp', 'ice_maker_fahrenheit.png'],
        za: ['ice_maker_celsius.webp', 'ice_maker_celsius.png'],
    };
    return arMap[locale as keyof typeof arMap] || arMap.za;
};

export const getTCGlacier = (locale: string) => {
    const map: any = {
        us: {
            title: 'crowdfunding.header.terms.title',
            desc: 'crowdfunding.header.terms.desc_glacier',
            links: ['https://www.youtube.com/@EcoFlowTech', 'https://www.facebook.com/ecoflowtech', 'https://www.instagram.com/ecoflowtech/'],
        },
        ca: {
            title: 'crowdfunding.header.terms.title',
            desc: 'crowdfunding.header.terms.desc_glacier',
            links: ['https://www.youtube.com/@EcoFlowTech', 'https://www.facebook.com/ecoflowtech', 'https://www.instagram.com/ecoflowtech/'],
        },
        jp: {
            title: 'crowdfunding.header.terms.title',
            desc: 'crowdfunding.header.terms.desc_glacier',
            links: [
                'https://jp.ecoflow.com/pages/price-guarantee',
                'mailto:support.jp@ecoflow.com',
                'mailto:support.jp@ecoflow.com',
                'https://jp.ecoflow.com/pages/warranty-policy',
                'https://jp.ecoflow.com/pages/online-store-policy',
            ],
        },
    };
    return map[locale] || map.us;
};
